// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"116":"0ead22a2","453":"28237ee8","458":"e9415dca"}[chunkId] + ".chunk.js";
};